export default function generatePageShortcuts(): Promise<any[]> {
    return new Promise(resolve => {
        if (window.top?.firebird.require) {
            window.top.firebird.require(['quick-search/utilities'], util => {
                Promise.all([
                    Promise.resolve(util.loadTexts()),
                    Promise.resolve(util.getPageActions()),
                    Promise.resolve(util.getRowActions()),
                    Promise.resolve(util.getEditActions()),
                    Promise.resolve(util.getCustomGroupsActions()),
                ]).then(([texts, pageActions, rowActions, editActions, customGroupsActions]) => {
                    const currentView = util.generateGroups(
                        texts,
                        pageActions,
                        rowActions,
                        editActions,
                        null,
                        customGroupsActions
                    )[0];

                    const cache: any[] = [];

                    currentView.subgroups.forEach(subGroup => {
                        subGroup.actions.forEach(link => {
                            cache.push({
                                title: link.text,
                                section: currentView.title,
                                group: subGroup.title !== 'empty' ? subGroup.title : null,
                                action: link.action,
                                type: 'link',
                            });
                        });
                    });

                    resolve(cache);
                });
            });
        } else {
            resolve([]);
        }
    });
}
